// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4LA10","title":"styles_title__ndfAc","depositLink":"styles_depositLink__gAp3b","empty":"styles_empty__Ss2eJ"};